import { Redirect } from 'react-router-dom';
import paths from '../../../config/local/paths';
import { withProperty } from '../PropertyProvider';
import React from 'react';

const PROPERTY_ROUTE_BY_TYPE = Object.freeze({
	appliances: paths.app.homeowner.properties.scoped.appliances,
	documents: paths.app.homeowner.properties.scoped.documents,
	finances: paths.app.homeowner.properties.scoped.finances,
	team: paths.app.homeowner.properties.scoped.team,
});

/**
 * @param {string} path
 * @returns {'documents'|'appliances'|'finances'|'details'}
 */
function getLegacyRouteType(path) {
	if (path === paths.app.homeowner.documents.root) {
		return 'documents';
	}

	if (path === paths.app.homeowner.applianceCenter.root) {
		return 'appliances';
	}

	if (path === paths.app.homeowner.finances) {
		return 'finances';
	}

	return 'details';
}

/**
 * @param {{
 *  match?: { path?: string },
 *  property: { selectedProperty?: { id?: string } | null }
 * }} props
 * @returns {JSX.Element}
 */
function LegacyPropertyScopedRedirect(props) {
	const routeType = getLegacyRouteType(props.match?.path);
	const propertyId = props.property.selectedProperty?.id;

	if (!propertyId) {
		return <Redirect to={paths.app.homeowner.properties.root} />;
	}

	const routeTemplate =
		PROPERTY_ROUTE_BY_TYPE[routeType] ??
		paths.app.homeowner.properties.scoped.details;

	return <Redirect to={routeTemplate.replace(':propertyId', propertyId)} />;
}

export default withProperty(LegacyPropertyScopedRedirect);
